import React, { Fragment, useState } from 'react'
import Table from 'UI/Table'
import { columns, subTableColumns } from './Columns'
import Filters from 'Features/Filters'
import filteredCertsData from './Data'

const expiresInOptions = [
  { value: [0, 0], label: 'Expired' },
  { value: [1, 30], label: 'Less than 30 days' },
  { value: [1, 60], label: 'Less than 60 days' },
  { value: [1, 90], label: 'Less than 90 days' },
  { value: [91, 100], label: 'More than 90 days' }
]

const IPAssetCertsTable = ({ hostsData }) => {
  const [filters, changeFilters] = useState({ expiresIn: 'All' })
  const data = filteredCertsData({ certs: hostsData, filters })

  const columns = [
    { Header: 'Client Name', accessor: 'viaje_client_name' },
    { Header: 'Cert Name', accessor: 'cert_name' },
    { Header: 'Usage count', accessor: 'usage_count' },
    { Header: 'Certificate issuer common name', accessor: 'certificate_issuer_common_name' },
    { Header: 'Cipher bits', accessor: 'cipher_bits' },
    { Header: 'Expired', accessor: 'expired' },
    { Header: 'Certificate issued at', accessor: 'certificate_issued_datetime' },
    { Header: 'Certificate expires at', accessor: 'certificate_expires_datetime', Cell: (row) => (
      <span style={{ color: row.original.expires_in_days_color }}>{row.original.certificate_expires_datetime}</span>
    ) },
  ]

  return (
    <Fragment>
      <Filters {...{ filters, onChange: changeFilters }}>
        <div className='col col-3'>
          <Filters.Select {...{ filterName: 'expiresIn', label: 'Cert Expires In', options: expiresInOptions, sortOptions: false }} />
        </div>
      </Filters>
      <Table
        columns={columns}
        data={data}
        filterable
        SubComponent={(row) => <Table filterable columns={subTableColumns} data={row.original.hosts} />}
      />
    </Fragment>
  )
}

export default IPAssetCertsTable
